import { Phone, Mail } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";
import { ContactForm } from "./ContactForm";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-forest py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <ChapterLabel number="04" title="Contact" />
        <h2 className="font-serif text-4xl sm:text-5xl text-cream leading-[1.05] tracking-tight max-w-2xl mb-16">
          Interested in Building <span className="italic text-brass">in Woodlake?</span>
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-sans text-base sm:text-lg leading-relaxed text-cream/75">
              Contact us to request additional information, discuss a specific homesite or arrange a time
              to visit the available properties.
            </p>
            <div className="mt-10">
              <p data-testid="contact-name" className="font-serif text-3xl text-cream">Brandy Bazile</p>
              <p className="font-sans text-sm text-cream/60 mt-1">Woodlake Estates Homesites</p>
            </div>
            <div className="mt-10 flex flex-col gap-4">
              <a
                data-testid="call-brandy-btn"
                href="tel:5043296166"
                className="flex items-center justify-between bg-brass text-forest font-sans text-sm font-semibold tracking-wide px-7 py-4 rounded-sm transition-colors duration-300 hover:bg-[#cbaa66]"
              >
                <span className="flex items-center gap-3"><Phone size={17} /> Call Brandy</span>
                <span className="font-normal">504-329-6166</span>
              </a>
              <a
                data-testid="email-brandy-btn"
                href="mailto:brandy4lsu@cox.net"
                className="flex items-center justify-between border border-cream/30 text-cream font-sans text-sm tracking-wide px-7 py-4 rounded-sm transition-colors duration-300 hover:bg-cream/10"
              >
                <span className="flex items-center gap-3"><Mail size={17} /> Email Brandy</span>
                <span className="font-normal text-cream/70">brandy4lsu@cox.net</span>
              </a>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <ContactForm />
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
